export const MenuStatuses = {
  Closed: 1,
  Opened: 2,
  TemporaryOpened: 3
}
